import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { ChevronRight, ChevronDown } from "lucide-react";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const [orders, setOrders] = useState({});
  const { user } = useAuth();
  const canSeeOrders = user?.role === "admin";

  useEffect(() => {
    api.get("/admin/customers").then((r) => setCustomers(r.data));
  }, []);

  const toggle = async (uid) => {
    if (!canSeeOrders) return;
    if (expanded === uid) {
      setExpanded(null);
      return;
    }
    setExpanded(uid);
    if (!orders[uid]) {
      const { data } = await api.get(`/admin/customers/${uid}/orders`);
      setOrders((prev) => ({ ...prev, [uid]: data }));
    }
  };

  return (
    <div data-testid="admin-customers">
      <div className="text-xs font-mono uppercase tracking-[0.3em] text-slate-500">Audience</div>
      <h1 className="mt-2 font-display font-extrabold text-4xl tracking-tight">Customers</h1>

      <div className="mt-8 bg-white rounded-2xl shadow-[0_4px_20px_-8px_rgba(0,0,0,0.08)] overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-secondary text-left">
            <tr>
              <th className="px-4 py-3 text-[10px] font-mono uppercase tracking-widest"></th>
              <th className="px-4 py-3 text-[10px] font-mono uppercase tracking-widest">Name</th>
              <th className="px-4 py-3 text-[10px] font-mono uppercase tracking-widest">Email</th>
              <th className="px-4 py-3 text-[10px] font-mono uppercase tracking-widest">Phone</th>
              <th className="px-4 py-3 text-[10px] font-mono uppercase tracking-widest">Joined</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((c) => (
              <React.Fragment key={c.id}>
                <tr className={`border-t border-black/5 ${canSeeOrders ? "hover:bg-secondary/50 cursor-pointer" : ""}`} onClick={() => toggle(c.id)}>
                  <td className="px-4 py-3 w-10">
                    {canSeeOrders && (expanded === c.id ? <ChevronDown size={14} /> : <ChevronRight size={14} />)}
                  </td>
                  <td className="px-4 py-3">{c.name}</td>
                  <td className="px-4 py-3 font-mono">{c.email}</td>
                  <td className="px-4 py-3 font-mono">{c.phone || "—"}</td>
                  <td className="px-4 py-3 font-mono text-slate-500">
                    {new Date(c.created_at).toLocaleDateString()}
                  </td>
                </tr>
                {expanded === c.id && (
                  <tr>
                    <td colSpan={5} className="bg-secondary/40 px-6 py-4">
                      <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-2">
                        Order history
                      </div>
                      {orders[c.id]?.length ? (
                        <div className="space-y-2">
                          {orders[c.id].map((o) => (
                            <div key={o.id} className="bg-white rounded-lg p-3 flex items-center gap-4 text-sm">
                              <div className="font-mono">#{o.id.slice(0, 8).toUpperCase()}</div>
                              <div className="font-mono text-slate-500">{new Date(o.created_at).toLocaleDateString()}</div>
                              <div className="font-mono">{o.items.length} items</div>
                              <div className="font-mono ml-auto">{o.total.toFixed(2)} JOD</div>
                              <span className="px-2 py-0.5 text-[10px] font-mono uppercase rounded-full bg-secondary">{o.status}</span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="text-sm font-mono text-slate-400">No orders yet.</div>
                      )}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
        {customers.length === 0 && (
          <div className="p-12 text-center text-slate-500 font-mono">No customers yet.</div>
        )}
      </div>
    </div>
  );
}
